/*
 * Aero-Gro — generic GA4 custom-event bridge.
 * Listens for clicks on any [data-ag-event] element (RO/water-assessment
 * CTAs, etc.) and forwards them as GA4 custom events via gtag(), plus
 * Shopify Customer Events for consistency with assets/ag-connect-events.js.
 * No external requests beyond the gtag.js already loaded in layout/theme.liquid.
 */
(function () {
  function handleClick(event) {
    var el = event.target.closest('[data-ag-event]');
    if (!el) return;

    var eventName = el.getAttribute('data-ag-event');
    if (!eventName) return;

    var params = {
      link_text: (el.textContent || '').trim().slice(0, 100),
      link_url: el.getAttribute('href') || null,
      page_path: window.location.pathname
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
    }

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      window.Shopify.analytics.publish(eventName, params);
    }
  }

  document.addEventListener('click', handleClick, true);
})();
